import React from "react";

import Navigation from '../components/Navigation';


const Jeunesse = () => {
    return(
        
        <div>
            <Navigation/>
            
            <h1>Voici les Jeunesse</h1>
            <p>
            </p>
        </div>
    )
}

export default Jeunesse